import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage }        from './pages/HomePage';
import { AtelierPage }     from './pages/AtelierPage';
import { CollectionsPage } from './pages/CollectionsPage';
import { MonturesPage }    from './pages/MonturesPage';
import { VerresPage }      from './pages/VerresPage';
import { SolairesPage }    from './pages/SolairesPage';
import { LunettesPage }    from './pages/LunettesPage';
import { LentillesPage }   from './pages/LentillesPage';
import { OrdonnancePage }  from './pages/OrdonnancePage';
import { ContactPage }     from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { LegalPage }       from './pages/LegalPage';
import { CookieBanner }    from './components/CookieBanner';
import { ScrollToTop }     from './components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/"                             element={<HomePage />} />
        <Route path="/atelier"                      element={<AtelierPage />} />
        <Route path="/collections"                  element={<CollectionsPage />} />
        <Route path="/montures"                     element={<MonturesPage />} />
        <Route path="/verres"                       element={<VerresPage />} />
        <Route path="/solaires"                     element={<SolairesPage />} />
        <Route path="/lunettes"                     element={<LunettesPage />} />
        <Route path="/lentilles"                    element={<LentillesPage />} />
        <Route path="/ordonnance"                   element={<OrdonnancePage />} />
        <Route path="/contact"                      element={<ContactPage />} />
        <Route path="/politique-de-confidentialite" element={<PrivacyPolicyPage />} />
        <Route path="/mentions-legales"             element={<LegalPage />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
